import React from 'react';
import classNames from 'clsx';
import MediaRenderer from '../media/MediaRenderer';
import { renderCustomOrDefaultComp } from '../utils';
const ItemRenderer = _ref => {
  let {
    data,
    selectors,
    customRenderers
  } = _ref;
  const props = {
    data,
    selectors,
    customRenderers
  };
  return /*#__PURE__*/React.createElement("a", {
    href: data.url,
    "aria-label": data.title,
    "aria-hidden": !data.url // hide it from assistive technologies for SEO
    ,
    target: "_blank",
    rel: "playground noreferrer"
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames('content')
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames('media')
  }, renderCustomOrDefaultComp(customRenderers == null ? void 0 : customRenderers.mediaRenderer, MediaRenderer, props)), /*#__PURE__*/React.createElement("div", {
    className: classNames('info', selectors == null ? void 0 : selectors.info)
  }, data.title)));
};
export default ItemRenderer;
//# sourceMappingURL=ItemRenderer.js.map